import React from "react";
import {  api } from "../../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";

const useContactNumber = () => {
    const devFrom = useAppSelector(({ ui }) => ui.DevFrom)
    React.useEffect(() => {
        if (devFrom && devFrom !== "")
            if (devFrom.startsWith("07"))
                api.fetchLast2ByMob({ telephoneMobile: devFrom })
            else api.fetchLast2ByLan({ telephoneLandline: devFrom })
    }, [devFrom])
}

export default useContactNumber;